import { Component, h, Prop } from '@stencil/core';
import Icon from '../svg/user-nurse-amber.svg'

@Component({
  tag: 'cr-icon-professional-lead',
  styleUrl: '../cr-icon.css',
  shadow: true,
})
export class CrIconProfessionalLead {

  /**
   * The size of the icon - can be 'small', 'medium' or 'large'
   */
  @Prop() size: string

  render() {

    return (
      <div
        class={this.size}
        innerHTML={Icon}
      />
    );
  }
}
